import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams, useRouteMatch, Link } from 'react-router-dom';
import { brandingVariables, HorizontalFlex, PadContainer } from 'smartsuite-ui';

export default function LocationAreaPanel(props) {
    const { description, bagCount, id: locationId } = props.locationSummary;

    const { flightId } = useParams();
    const { url } = useRouteMatch();
    const history = useHistory();

    // function onClick() {
    //     history.push(`${url}/${flightId}/${locationId}`);
    // }

    return (
        <div className="location-area">
            <Link to={`${url}/${locationId}`}>{description}</Link>
            <span className="location-area__bag-count">{bagCount || '-'}</span>
        </div>
    );
}

LocationAreaPanel.propTypes = {
    locationSummary: PropTypes.instanceOf(Object).isRequired,
};
